import { Component, OnInit, OnDestroy } from '@angular/core';
import { Helper } from 'src/app/shared/helper';
import { environment } from 'src/app/config/env';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit, OnDestroy {
  adminRoot = environment.adminRoot;

  constructor(public _helper:Helper) { }

  ngOnInit(): void {
    document.body.classList.add('background');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('background');
  }

}
